import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CountryService from "../../../services/CountryServices/CountryService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Card,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Table,
  TabPane,
} from "reactstrap";

const CountryDetail = () => {
  const { id } = useParams();

  const [data, setData] = useState([]);
  console.log("🚀 ~ CountryDetail ~ data:", data);
  const fetchData = async () => {
    try {
      const response = await CountryService.getById(id);
      setData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const [activeTab, setActiveTab] = useState("1");

  const tabToggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <div className="">
      <div className="page-content">
        <div className="container-fluid">
          <BreadCrumb
            pageTitle="Country"
            title="Country Detail"
            breadcrumbItems={[{ title: "Back To List ", link: "/country" }]}
          />
        </div>

        <Card className="p-4">
          <div className="mb-3">
            <h6>Country Name: {data?.name}</h6>
            <h6>Country Code: {data?.code}</h6>
            <h6>State Label: {data?.state_label}</h6>
            <h6>Suburb Label: {data?.suburb_label}</h6>
          </div>

          <Nav
            className="nav-tabs-custom rounded card-header-tabs border-bottom-0 mb-3"
            role="tablist"
          >
            <NavItem>
              <NavLink
                className={`cursor-pointer ${
                  activeTab === "1" ? "active border-0" : ""
                }`}
                onClick={() => {
                  tabToggle("1");
                }}
              >
                {data?.state_label || "States"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`cursor-pointer ${
                  activeTab === "2" ? "active " : ""
                }`}
                onClick={() => {
                  tabToggle("2");
                }}
              >
                Zip Code
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <div>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>S.N</th>
                      <th>{data?.state_label} Name</th>
                      <th>{data?.state_label} Code</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.states?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item?.name}</td>
                        <td>{item?.code}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </TabPane>
            <TabPane tabId="1"></TabPane>
          </TabContent>
        </Card>
      </div>
    </div>
  );
};

export default CountryDetail;
